export const translatePolicyRole = (policyRole) => {
    const policyRoleTranslations = {
        InsuredPolicy: "Police Assurée",
        AdversePolicy: "Police Adverse",
    };
    return policyRoleTranslations[policyRole] || policyRole;
};